<style>
  .frame::-webkit-scrollbar {
    -webkit-appearance: none;
  }

    .frame::-webkit-scrollbar:vertical {
      width: 11px;
    }

    .frame::-webkit-scrollbar:horizontal {
      height: 11px;
    }

  .frame::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }

  .frame::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 8px;
  }

  /*No footer in dialog fix */
  mat-dialog-content {
    overflow: initial !important;
  }

  .mat-dialog-container {
    height: auto !important;
  }

  .errormessage {
    color: red;
    font-size: 90%;
    font-style: italic;
  }

  .warning-box {
    border: 1px solid red;
    background-color: #ffe5e5; /* Light red background */
    padding: 20px;
    margin: 10px auto 20px auto;
    font-weight: bold;
  }

  .dialog-header {
    margin: 0 0 24px 0;
    text-align: left;
  }

  .dialog-shell {
    padding: 0 16px 16px 16px;
  }

  .dialog-title {
    margin: 0;
    padding-left: 0;
  }

  [mat-dialog-title] {
    margin: 0;
    padding: 0;
  }

  .dialog-title-strong {
    font-size: 1.6rem;
    font-weight: 600;
  }

  .dialog-subtitle {
    margin: 6px 0 0 0;
    color: #5b5b5c;
  }

  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
</style>

<div class="dialog-shell">
  <div class="dialog-header">
    <h1 class="dialog-title" mat-dialog-title *ngIf="isNewCustomer">Ny kund</h1>
    <h2 class="dialog-title dialog-title-strong" mat-dialog-title *ngIf="!isNewCustomer">Kund</h2>
  </div>

<div *ngIf="!isNewCustomer && !customer.Active">Kund med detta organisationsnummer kan inte användas längre.</div>

<form #personForm="ngForm" novalidate>

  <div *ngIf="isAdmin" style="display: inline-block;">
    <mat-checkbox [(ngModel)]="customer.Global" name="_global" (change)="customer.Global = $event.checked" style="margin-right: 25px;">Global kund</mat-checkbox>

    <mat-checkbox [(ngModel)]="customer.Active" name="_active" (change)="customer.Active = $event.checked">Aktiv</mat-checkbox>
  </div>


  <!--Regular text field shown to admin, and only as text to member-->
  <div *ngIf="isAdmin">
    <mat-form-field floatLabel="always" style="width:100%; margin-top:20px;">
      <mat-label>Info om kunden som syns för medlem</mat-label>
      <input matInput type="text" [(ngModel)]='customer.PublicInfo' [disabled]="!isAdmin" placeholder="Info om kunden som syns för medlem" name="PublicInfo">
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin">
    <mat-form-field floatLabel="always" style="width:100%; margin-bottom:20px;">
      <mat-label>Info om kunden som enbart syns för admin</mat-label>
      <input matInput type="text" [(ngModel)]='customer.AdminInfo' [disabled]="!isAdmin" placeholder="Info om kunden som enbart syns för admin" name="AdminInfo">
    </mat-form-field>
  </div>

  <div class="row" style="margin-bottom: 10px;">
    <div class="col-12">
      <span class="bold">Kundtyp: </span>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [(ngModel)]="customer.IsCompany" [disabled]="!isNewCustomer && !isAdmin" name="_isPrivatePerson2" (change)="IsCompanyOnChange(customer,$event.checked)">Företag</mat-checkbox>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [ngModel]="!customer.IsCompany" (ngModelChange)="customer.IsCompany = $event" [disabled]="!isNewCustomer && !isAdmin" name="_isPrivatePerson" (change)="IsCompanyOnChange(customer,!$event.checked)" style="margin-left:15px;">Privatperson</mat-checkbox>
    </div>
  </div>

  <!-- Visa/dölj i fakturaverktygets lista -->
  <div class="row" style="margin-bottom: 10px;">
    <div class="col-12">
      <span class="bold">Visa i fakturaverktygets kundlista: </span>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [(ngModel)]="customer.ActiveInList" (change)="customer.ActiveInList = $event.checked;" name="activeInListYes">Ja</mat-checkbox>
    </div>
    <div class="col-lg-3">
      <mat-checkbox [ngModel]="!customer.ActiveInList" (ngModelChange)="customer.ActiveInList = $event" (change)="customer.ActiveInList = !$event.checked;" style="margin-left:15px;" name="activeInListNo">Nej</mat-checkbox>
    </div>
  </div>


  <p *ngIf="!isAdmin && customer.PublicInfo" class="warning-box">{{ customer.PublicInfo }}</p>


  <mat-form-field floatLabel="always" *ngIf="customer.Country.Id != null" style="width:100%; margin-top:15px;">
    <mat-label>Land</mat-label>
    <mat-select [disabled]="countrySelectionLocked || (!isNewCustomer && !isAdmin)" name="country"
                [ngModel]="customer?.Country?.Id"
                (ngModelChange)="customer && customer.Country ? (customer.Country.Id = $event) : null; onCountryChange($event, true)" [ngModelOptions]="{standalone: true}" required>
      <mat-option *ngFor="let c of countries" [value]="c.Id">
        {{ c.Name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!--Searchbox only shown to users adding a new business customer-->
  <div *ngIf="customer.IsCompany && isNewCustomer">
    <div style="margin: 0 0 0 0;">
      <mat-form-field floatLabel="always" style="width:100%;">
        <mat-label>Organisationsnummer</mat-label>
        <input matInput [(ngModel)]="searchAccountValue"
               (ngModelChange)="orgNumberValidCheck($event)"
               pattern="{{customer?.Country?.VatRegexPattern}}"
               name="searchCompany"
               id="searchCompany"
               type="text"
               placeholder="{{customer?.Country?.VatPlaceholder}}">
        <mat-hint align="start">
          {{ customer?.Country?.VatDescription }}
        </mat-hint>
        <mat-icon *ngIf="orgNumberValid" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kontrollerat hos Hitta.se" style="color:green;">check</mat-icon>
        <mat-icon *ngIf="!orgNumberValid && !isSearchingCompany" color="accent" matSuffix matTooltipPosition="before" matTooltip="Företaget kan ej verifieras" style="color:red;">close</mat-icon>
        <mat-progress-spinner *ngIf="isSearchingCompany && customer?.Country?.Name === 'Sverige'" matSuffix mode="indeterminate" diameter="20"></mat-progress-spinner>
      </mat-form-field>

      <span class="errormessage">{{errorMessageOrgnr}} {{noResultMessage}}</span>
    </div>
  </div>

  <!--Regular text field shown to admin, and disabled for users when a customer is once saved-->
  <div *ngIf="customer.IsCompany && (!isNewCustomer || isAdmin && !orgNumberValid)">
    <h4 *ngIf="isAdmin"><b>Fyll i här om orgnr ej kan hittas</b></h4>
    <mat-form-field floatLabel="always" style="width:100%; margin-bottom:20px;">
      <mat-label>Organisationsnummer / VAT</mat-label>
      <input matInput type="text" [(ngModel)]='customer.OrgNumber'
             [disabled]="!isNewCustomer && !isAdmin"
             placeholder="NNNNNN-NNNN (10 siffror och bindestreck)"
             [required]="(customer?.Country?.Name === 'Sverige') || (customer?.Country?.VatRegexPattern && customer?.Country?.VatRegexPattern.length > 0)"
             name="OrgNumber">
    </mat-form-field>
  </div>

  <!--Other form fields are shown when orgnr is added, or if private person customer. Always shown to admin-->
  <!-- Personnummer -->
  <mat-form-field floatLabel="always" style="width:100%; margin-top:20px;"
                  *ngIf="!customer.IsCompany">
    <mat-label>Personnummer</mat-label>
    <input matInput type="text" [disabled]="(!isNewCustomer || customer.OrgNumberLocked) && !isAdmin"
           (ngModelChange)="pNumberValidCheck($event)"
           [(ngModel)]='customer.OrgNumber' placeholder="ÅÅÅÅMMDDNNNN (12 siffror utan bindestreck)" required name="Personnummer">
    <mat-icon *ngIf="!pNrValid && !isNewCustomer && !isSearchingPerson" color="accent" matSuffix matTooltipPosition="before" matTooltip="Personen ej verifierad" style="color:red;">close</mat-icon>
    <mat-progress-spinner *ngIf="isSearchingPerson && customer?.Country?.Name === 'Sverige'" matSuffix mode="indeterminate" diameter="20"></mat-progress-spinner>
  </mat-form-field>
  <span *ngIf="isAdmin" class="errormessage">{{ customer.AdminInfo }}</span><br />
  <div class="errormessage">{{errorMessageSpar}}</div>

  <mat-form-field floatLabel="always" *ngIf="isAdmin || orgNumberValid || pNrValid || !isNewCustomer" style="width:100%; margin-top: 20px;">
    <mat-label>Namn</mat-label>
    <input matInput type="text" [disabled]="customer.NameLocked && !isAdmin"
           [(ngModel)]='customer.Name' required name="name">
  </mat-form-field>


  <span *ngIf="!customer.IsCompany && !pNrValid" class="errormessage">{{errorMessagePnr}}</span>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Telefon</mat-label>
    <input matInput type="text" [disabled]="customer.PhoneLocked && !isAdmin" (ngModelChange)="phoneNumberValidCheck($event)"
           [(ngModel)]='customer.Phone' name="Phone">
  </mat-form-field>

  <span class="errormessage">{{errorMessagePhoneNr}}</span>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Epost för faktura</mat-label>
    <input matInput type="email" [disabled]="customer.InvoiceEmailLocked && !isAdmin" #correctEmail='ngModel' ngModel [(ngModel)]='customer.InvoiceEmail' name="InvoiceEmail">
    <mat-icon *ngIf="!correctEmail.valid && !customer.InvoiceEmailLocked" matSuffix color="accent">warning</mat-icon>
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="isAdmin && customer.IsCompany" style="width:100%;">
    <mat-label>Epost för mailin</mat-label>
    <input matInput type="email" ngModel [(ngModel)]='customer.MailinInboxEmail' name="MailinInboxEmail">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>C/o</mat-label>
    <input matInput type="text" [disabled]="customer.CoLocked && !isAdmin" [(ngModel)]='customer.Co' name="Co">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Adress</mat-label>
    <input matInput type="text" [disabled]="customer.AddressLocked && !isAdmin"
           [(ngModel)]='customer.Address' required name="Address">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Adress 2</mat-label>
    <input matInput type="text" [disabled]="customer.Address2Locked && !isAdmin"
           [(ngModel)]='customer.Address2' name="Address 2">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Postnummer</mat-label>
    <input matInput type="text" [disabled]="customer.ZipLocked && !isAdmin"
           [(ngModel)]='customer.Zip' required name="Zip">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="pNrValid || orgNumberValid || !isNewCustomer" style="width:100%;">
    <mat-label>Ort</mat-label>
    <input matInput type="text" [disabled]="customer.CityLocked && !isAdmin"
           [(ngModel)]='customer.City' required name="City">
  </mat-form-field>

  <mat-form-field floatLabel="always" *ngIf="(!pNrValid && orgNumberValid) || !isNewCustomer" appearance="fill" style="width:100%;">
    <mat-label>GLN-nummer (ej obligatorisk)</mat-label>
    <input matInput type="text" [disabled]="customer.GlnNumberLocked && !isAdmin" [(ngModel)]='customer.GlnNumber' placeholder="GLN-nummer för EDI" name="glnnumber">
    <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="GLN-nummer är endast krav när man skickar en EDI (e-faktura), vilket inte ska förväxlas med PDF-faktura via e-post. Man kan förklara GLN-nummer som en adress dit man skickar den elektroniska fakturan. Din kund kan förse dig med den information du behöver.">info</mat-icon>
  </mat-form-field>

  <div *ngIf="customer.IsCompany && (isAdmin || orgNumberValid || !isNewCustomer)">
    <p>Förvald leveransmetod för faktura</p>
    <mat-radio-group name="invoiceSendType" [(ngModel)]="customer.InvoiceSendType">
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="0">Ingen förvald</mat-radio-button>
      <!--<mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="2">Post</mat-radio-button>-->
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="1">E-post (pdf)</mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [disabled]="customer.InvoiceSendTypeLocked && !isAdmin" [value]="3">EDI</mat-radio-button>
    </mat-radio-group>
    <br><br>

    <div *ngIf="isAdmin" class="row" style="margin-bottom: 20px;">
      <div class="col-lg-12">
        <span class="bold" style="position: relative; top: 18px;">Betalvillkor:</span>
      </div>
      <div class="col-lg-12">
        <mat-form-field floatLabel="always">
          <mat-label>Betalvillkor</mat-label>
          <mat-select [ngModel]="customer.PaymentTerm" (ngModelChange)="customer.PaymentTerm = $event" name="paymentterm">
            <mat-option *ngFor="let item of paymentTerms" [value]="item">{{item}} dagar</mat-option>
          </mat-select>
        </mat-form-field>
        <p style="font-style: italic;">0 dagar = inget förvalt värde</p>
      </div>
    </div>

    <div *ngIf="isAdmin" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Kunden kräver elektronisk referens: </span>
      </div>
      <div class="col-12">
        <mat-checkbox [(ngModel)]="customer.ElectronicReferenceMandatory" (change)="customer.ElectronicReferenceMandatory = $event.checked;" name="referenceyes">Ja</mat-checkbox>
        <mat-checkbox [ngModel]="!customer.ElectronicReferenceMandatory" (ngModelChange)="customer.ElectronicReferenceMandatory = $event" (change)="customer.ElectronicReferenceMandatory = !$event.checked;" style="margin-left:15px;" name="referenceno">Nej</mat-checkbox>
      </div>
    </div>

    <!--If electronic reference is mandatory-->
    <div *ngIf="customer.ElectronicReferenceMandatory && !isAdmin" style="margin-bottom: 20px;">
      <mat-form-field floatLabel="always" appearance="fill" style="width:100%;">
        <mat-label>Elektronisk referens</mat-label>
        <input matInput type="text" [(ngModel)]='customer.ElectronicReference' name="ereference">
        <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor.">info</mat-icon>
      </mat-form-field>
      <span style="font-size: 80%; font-style: italic;">Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor. Du kan fylla i en referenskod här så att de automatiskt adderas på framtida fakturor (som går att ändra när du skapar en faktura) eller så kan du fylla i informationen när du skapar en faktura.</span>
    </div>


    <!--If electronic reference is not mandatory-->
    <div *ngIf="(!customer.ElectronicReferenceMandatory && !isAdmin) || isAdmin">
      <mat-form-field floatLabel="always" appearance="fill" style="width:100%;">
        <mat-label>Elektronisk referens</mat-label>
        <input matInput type="text" [(ngModel)]='customer.ElectronicReference' name="ereference">
        <mat-icon color="accent" matSuffix matTooltipPosition="before" area-label="Hover to display info" matTooltip="Din kund kräver elektronisk referens på e-fakturor. Oftast är detta en sifferkod, men kan variera. Om du inte fått info från din kund behöver du fråga din kund efter elektronisk referens på e-fakturor.">info</mat-icon>
      </mat-form-field>
    </div>

    <div *ngIf="isAdmin" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Kunden godkänner fakturaavgift: </span>
      </div>
      <div class="col-12">
        <mat-checkbox [disabled]="customer.AcceptsInvoiceFeeLocked && !isAdmin" [(ngModel)]="customer.AcceptsInvoiceFee" (change)="customer.AcceptsInvoiceFee = $event.checked;" name="yes">Ja</mat-checkbox>
        <mat-checkbox [disabled]="customer.AcceptsInvoiceFeeLocked && !isAdmin " [ngModel]="!customer.AcceptsInvoiceFee" (ngModelChange)="customer.AcceptsInvoiceFee = $event" (change)="customer.AcceptsInvoiceFee = !$event.checked;" style="margin-left:15px;" name="no">Nej</mat-checkbox>
      </div>
    </div>
    <div *ngIf="!isNewCustomer &&!isAdmin && customer.AcceptsInvoiceFeeLocked && !customer.AcceptsInvoiceFee" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Denna kund godkänner inte att du fakturerar dem för fakturaavgiften.</span>
      </div>
    </div>

    <div *ngIf="isAdmin" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Kunden kräver detaljerad tidrapport: </span>
      </div>
      <div class="col-12">
        <mat-checkbox [disabled]="customer.TimeReportMandatory && !isAdmin" [(ngModel)]="customer.TimeReportMandatory" (change)="customer.TimeReportMandatory = $event.checked;" name="timeyes">Ja</mat-checkbox>
        <mat-checkbox [disabled]="customer.TimeReportMandatory && !isAdmin " [ngModel]="!customer.TimeReportMandatory" (ngModelChange)="customer.TimeReportMandatory = $event" (change)="customer.TimeReportMandatory = !$event.checked;" style="margin-left:15px;" name="timeno">Nej</mat-checkbox>
      </div>
    </div>
    <div *ngIf="!isAdmin && customer.TimeReportMandatory" class="row" style="margin-bottom: 10px;">
      <div class="col-12">
        <span class="bold">Denna kund kräver att du anger detaljerad tidrapport på din faktura.</span>
      </div>
    </div>


  </div>

</form>

<div>{{errorMessage}}</div>
<div class="errormessage">{{errorMessageSpar}}</div>

  <div class="dialog-actions">
    <button mat-button type="button" (click)="cancel()">Avbryt</button>
    <button mat-raised-button color="accent"
            [disabled]="!isAdmin && (!formValid() || (!customer.IsCompany && !pNrValid))"
            (click)="save(customer)">
      <mat-icon>check</mat-icon>
      &nbsp;Spara&nbsp;
    </button>
  </div>
</div>

